import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext();
const API = process.env.REACT_APP_BACKEND_URL;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('trxl_token'));
  const [loading, setLoading] = useState(true);

  const fetchProfile = useCallback(async (t) => {
    try {
      const res = await fetch(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data);
      } else {
        localStorage.removeItem('trxl_token');
        setToken(null);
        setUser(null);
      }
    } catch {
      /* silent */
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (token) fetchProfile(token);
    else setLoading(false);
  }, [token, fetchProfile]);

  const login = async (email, password) => {
    const res = await fetch(`${API}/api/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Server-Fehler. Bitte später erneut versuchen.');
    }
    if (!res.ok) throw new Error(data.detail || 'Login fehlgeschlagen');
    localStorage.setItem('trxl_token', data.token);
    setToken(data.token);
    setUser(data.user);
    // Link session cart to user
    fetch(`${API}/api/cart/link-user`, {
      method: 'POST', headers: { Authorization: `Bearer ${data.token}` }, credentials: 'include'
    }).catch(() => {});
    return data;
  };

  const register = async (formData) => {
    const res = await fetch(`${API}/api/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });
    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error('Server-Fehler. Bitte später erneut versuchen.');
    }
    if (!res.ok) throw new Error(data.detail || 'Registrierung fehlgeschlagen');
    localStorage.setItem('trxl_token', data.token);
    setToken(data.token);
    setUser(data.user);
    // Link session cart to user
    fetch(`${API}/api/cart/link-user`, {
      method: 'POST', headers: { Authorization: `Bearer ${data.token}` }, credentials: 'include'
    }).catch(() => {});
    return data;
  };

  const logout = () => {
    localStorage.removeItem('trxl_token');
    setToken(null);
    setUser(null);
  };

  const updateProfile = async (updates) => {
    const res = await fetch(`${API}/api/auth/me`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(updates),
    });
    if (res.ok) {
      const data = await res.json();
      setUser(data);
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
